
jQuery('#iconSlider').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    infinite: true,
    pauseOnHover:false,
    responsive: [
        {
            breakpoint: 1300,
            settings: {
                slidesToShow: 5,
            }
        },
        {
            breakpoint: 678,
            settings: {
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 520,
            settings: {
                slidesToShow: 2,
            }
        }
    ]
});